// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"22384111","92":"5d9cb4aa","99":"c4074dfd","215":"ff68962e","337":"6771ac3c","443":"8cd8f3cf","453":"eca5f793","479":"80edd896","531":"9f736a10","952":"2580a8c6"}[chunkId] + ".chunk.js";
};